<template>
  <Transition
    @enter="onEnter"
    @leave="onLeave"
    appear
  >
    <div
      v-show="show"
      class="the-transition"
      ref="refRoot"
    >
      <div class="bg">
        <div
          v-for="(row, rowIdx) in numRows"
          class="row"
          :key="`transition-row-${row}`"
        >
          <div
            v-for="(col, colIdx) in numCols"
            class="col"
            :key="`transition-col-${row}-${col}`"
          >
            <div
              class="block"
              :row="row"
              :col="col"
            >
              <div class="gradient" />
            </div>
          </div>
        </div>
      </div>

      <TheLogo class="icon" />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { SITE_IN_DURATION } from "@/config"
// import IconLogo from "@/icons/logo-small.svg?component"
import { PageState } from "@/providers/page/pageState"
import { useAppStore } from "@/stores/app"

const props = defineProps({})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

const numRows = 4
const numCols = 6

const onEnter = function (el, done) {
  const tl = $gsap.timeline({ onComplete: done })

  const q = $gsap.utils.selector(refRoot.value)

  let rows = q(".row")
  rows = [...rows].reverse()

  tl.add("in")
  for (let idx = 0; idx < rows.length; idx++) {
    // console.log(idx, block)
    const row = rows[idx]
    const block = row.querySelectorAll(".block")

    tl.fromTo(
      block,
      { x: "-101%" },
      {
        x: 0,
        duration: 0.5,
        stagger: 0.1,
      },
      `in+=${idx * 0.15}`
    )
  }

  tl.fromTo(q(".icon"), { opacity: 0 }, { opacity: 1, duration: 0.5 }, "-=0.5")

  let targetDuration = SITE_IN_DURATION * 0.8
  tl.timeScale(tl.duration() / targetDuration)

  return tl.then()
}

const onLeave = function (el, done) {
  const tl = $gsap.timeline({ onComplete: done })

  const q = $gsap.utils.selector(refRoot.value)

  let rows = q(".row")
  rows = [...rows].reverse()
  // console.log("animatein")

  tl.add("out")
  tl.to(q(".icon"), { opacity: 0, duration: 0.5 }, "out")

  for (let idx = 0; idx < rows.length; idx++) {
    const row = rows[idx]
    const block = row.querySelectorAll(".block")

    tl.to(
      block,
      {
        x: "101%",
        duration: 0.5,
        stagger: 0.1,
      },
      `out+=${idx * 0.15}`
    )
  }

  let targetDuration = 1.0
  tl.timeScale(tl.duration() / targetDuration)

  return tl.then()
}

const show = ref(false)

const onPageStateChange = (state) => {
  // console.log("TheTransition.onPageStateChange", state)
  switch (state) {
    case PageState.LeaveStart:
      // case PageState.LeaveComplete:
      // case PageState.Preload:
      // case PageState.PreloadComplete:
      app.setModalId(null)
      show.value = true
      break
    case PageState.EnterStart:
      show.value = false
      break

    default:
      break
  }
}

watch(() => app.pageState, onPageStateChange)
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";
</style>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.the-transition {
  @include fill();
  @include flex(column);
  position: fixed;
  z-index: 1000;
  // pointer-events: none;
}

.bg {
  @include fill();
  @include flex(column, center, stretch);

  .row {
    flex: 1;
    @include flex(row, stretch, stretch);
  }
  .col {
    position: relative;
    flex: 1;
    overflow: hidden;
  }
  .block {
    @include fill;
    overflow: hidden;

    .gradient {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100lvh;
      // background: linear-gradient(
      //   180deg,
      //   #ef9fcc -3.57%,
      //   #e0a1a3 43.32%,
      //   #f58556 101.75%
      // );
      @include animatedBg();
    }

    @for $i from 1 through 4 {
      &[row="#{$i}"] {
        .gradient {
          top: -100lvh / 4 * ($i - 1);
        }
      }
    }

    @for $i from 1 through 6 {
      &[col="#{$i}"] {
        .gradient {
          left: -100vw / 6 * ($i - 1);
        }
      }
    }
  }
}

.icon {
  position: relative;
  height: 3.5rem * 2;
}
</style>
